import { render, staticRenderFns } from "./work_data.vue?vue&type=template&id=0a48ee66&scoped=true"
import script from "./work_data.vue?vue&type=script&lang=js"
export * from "./work_data.vue?vue&type=script&lang=js"
import style0 from "./work_data.vue?vue&type=style&index=0&id=0a48ee66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48ee66",
  null
  
)

export default component.exports